import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'x-flag-icon',
  templateUrl: './flag-icon.component.html',
  styleUrls: ['./flag-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlagIconComponent {
  @Input() set flag(code: string | undefined | null) {
    if (!code) return;

    const lcCode = code.toLowerCase();

    if (lcCode === 'int') {
      this._backgroundUrl =
        'https://res.cloudinary.com/babylon/image/upload/v1667208396/babylonstoren/icons/filled_globe.svg';
      return;
    }

    this._backgroundUrl = `https://flagcdn.com/${lcCode}.svg`;
  }

  @Input()
  size: 'small' | 'medium' | 'large' = 'small';

  get backgroundUrl() {
    return `url(${this._backgroundUrl})`;
  }

  _backgroundUrl: string | null;
}
